import React from 'react';
import {GroupTypeBase, OptionTypeBase} from 'react-select/src/types';
import {Props} from 'react-select';
import 'config/react-select.css'

export interface ReactSelectProps<OptionType extends OptionTypeBase,
	IsMulti extends boolean = false,
	GroupType extends GroupTypeBase<OptionType> = GroupTypeBase<OptionType>> extends Props<OptionType, IsMulti, GroupType> {
}

/**
	Use {menuPortalTarget: false} prop when in popup. (bug: scroll background with portalled menu away, so that it is not anymore connected to input position. on select with touch, the wrong value may get selected because the menu snaps to the input element on hover/mouseover)
 */
export function getReactSelectDefaultProps<OptionType extends OptionTypeBase,
	IsMulti extends boolean = false,
	GroupType extends GroupTypeBase<OptionType> = GroupTypeBase<OptionType>>({styles, ...props}: ReactSelectProps<OptionType, IsMulti, GroupType>): ReactSelectProps<OptionType, IsMulti, GroupType> {
	return {
		// menuPortalTarget: document.body, // do not use portalling in popups (see js-doc above)
		autoFocus: false,
		hideSelectedOptions: false,
		placeholder: "Auswählen...",
		noOptionsMessage: () => "Keine Einträge gefunden",
		loadingMessage: () => "Laden...",
		styles: {
			noOptionsMessage: (base, props) => ({
				...base,
				whiteSpace: 'pre-line',
			}),
			option: (base) => ({
				...base,
				wordBreak: 'break-word',
			}),
			menuPortal: (base) => ({
				...base,
				zIndex: 2000,
				top: typeof base.top === 'number' ? +base.top - 7 : base.top,
			}),
			menu: (base) => ({
				...base,
				zIndex: 2000,
				boxShadow: '0 4px 16px hsla(0,0%,0%,0.7)',
				width: props.isAze && "max-content" || '100%',
				minWidth: '100%',
			}),
			input: (base, inputProps) => ({
				...base,
				visibility: "visible",
				color: inputProps.isDisabled ? '#363232' : '#000',
			}),
			dropdownIndicator: base => ({...base, padding: 4}),
			clearIndicator: base => ({...base, padding: 4}),
			groupHeading: (base) => ({
				...base,
				position: 'sticky',
				background: '#ffffff',
				top: -5,
				paddingTop: 5,
				paddingBottom: 5,
			}),
			multiValueRemove: (base) => ({
				...base,
				background: 'inherit',
			}),
			...styles,
		},
		...props,
	}
}